import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class AssetService {
  constructor(private api: ApiService) {}

  PATH = 'v1/asset';

  /**
   * Generate an image with the merchant logo overlaid on the top right
   * and location QR code on the bottom right (if locationId is provided)
   * @param imageUrl The URL of the image to process
   * @param locationId Optional ID of the location to use for QR code
   * @returns Observable with the processed image URL
   */
  generateWithLogo(imageUrl: string, locationId?: string) {
    return this.api.post(`${this.PATH}/generate-with-logo`, {
      imageUrl,
      locationId,
    });
  }
}
